import React, { Component } from 'react'

class ItemList extends Component {
  render() {
    return (
      <div style={{ margin: '20px 0' }}>
        Permission Denied.
      </div>
    )
  }
}

export default ItemList